import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function AngularMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Introduction to Angular JS</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Introduction to Angular JS
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          A structural framework for dynamic web apps, created by Google and released in 2010.<br/>
Built on top of JavaScript, it extends HTML's syntax to create a more expressive and powerful way to build 
single-page applications (SPAs).<br/>
Emphasizes declarative programming, dependency injection, and data binding to simplify development and maintainability.

          </Typography>
        </Box>
      </Modal>
    </div>
  );
}